/* eslint-disable react-hooks/exhaustive-deps */
import {
  AddOutlined,
  Close,
  NavigateBefore,
  VisibilityOutlined,
} from "@mui/icons-material";
import { Box, Button, IconButton, InputAdornment, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatchWrapper } from "../../../hooks";
import {
  defaultMarketCampaignQuickSendList,
  IMarketCampaignAudience,
  IMarketCampaignQuickSendList,
} from "../../../redux/marketCampaign/marketCampaign.types";
import { useTableV2State } from "../../../components/TableV2/hooks/useTableV2State";
import { useBillingCompanyContext } from "../../../providers";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../components/TableV2/interfaces/IDataTableV2Props";
import { LoadState } from "../../../constants/enums";
import { CustomChip } from "../../../components/CustomChip";
import {
  fetchAllMarketCampaignAudienceListAsync,
  upsertDraftStepAsync,
  upsertMarketCampaignAudienceAsync,
  upsertQuickSendCampaignListAsync,
} from "../../../redux/marketCampaign/marketCampaignActions";
import { PageContainer } from "../../../components/container/PageContainer";
import { PageTitleBar } from "../../../components/PageTitleBar/PageTitleBar";
import { DataTableV2 } from "../../../components/TableV2/DataTableV2";
import { CreateAudienceRightPanel } from "./create-new-audience/CreateAudienceRightPanel";
import {
  CustomCheckbox,
  CustomTextField,
} from "../../../components/formsComponents";
import { useDebounce } from "../../../hooks/useDebounce";
import produce from "immer";
import { TABLE_CACHING_KEYS } from "../../../constants/constants";
import { showMessage } from "../../../redux/messages/messagesActions";
import { useMarketCampaignContext } from "../MarketCampaign.context-state";
import { useReduxStore } from "../../../redux/store.hooks";
import { batch } from "react-redux";
import { useFormik } from "formik";
import { PreviewOrUpdateChoosenAudieneRP } from "./PreviewOrUpdateChoosenAudieneRP";
import { fetchUniqueMarketCampaignQuickSendListAsync } from "../services/MarketCampaignAudience.service";
import { extractCombinedHeaders } from "../../marketingCampaign/components/ExcelFileUplaodButtonAsyncV2";
import { useTimezoneFormatter } from "../../../hooks/useTimezoneFormatter";

export const ManageAudienceList: React.FC<{
  onRowSelect?: (row: any) => void;
  selectedRowProp?: any;
  onNext: () => void;
  onBackClick: () => void;
}> = (props) => {
  const dispatch = useDispatchWrapper();
  const { ftDateTime } = useTimezoneFormatter();
  const companyOutlet = useBillingCompanyContext();
  const { marketCampaign, isEditable, draftSteps, onKeyChange } =
    useMarketCampaignContext();

  const {
    list: multipleAudienceList,
    loading,
    data: singleAudience,
  } = useReduxStore("marketCampaign").marketCampaignAudience;

  const [openCreateView, setOpenCreateView] = React.useState<any>(null);
  const [previewSelectedAudienceDialog, setPreviewSelectedAudienceDialog] =
    React.useState<IMarketCampaignAudience | null>(null);
  const [selectedRows, setSelectedRows] = useState<IMarketCampaignAudience[]>(
    [],
  );
  const [defaultApiRows, setDefaultApiRows] = useState<
    IMarketCampaignAudience[]
  >([]);
  const [filteredApiRows, setFilteredApiRows] = useState<
    IMarketCampaignAudience[]
  >([]);

  const [quickSendDataList, setQuickSendDataList] =
    useState<IMarketCampaignQuickSendList>(defaultMarketCampaignQuickSendList);

  const {
    state: {
      pagination,
      masterColumnResize,
      otherCustomStateProperties,
      searchState,
      dateState,
      tabs,
    },
    setState,
    onPageChange,
    onRowsPerPageChange,
    onResizeMasterColumns,
  } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last30Days",
      selectedTab: "-1",
    },
    pagination: {
      pageNumber: 1,
      rowsInPerPage: 25,
      apiFetchRowCount: 26,
      extraFetchFactor: 1,
    },
    otherCustomStateProperties: {
      searchByName: "",
    },
    cachingFilters: {
      uniqueKey: TABLE_CACHING_KEYS.MARKETING_AUDIENCE,
    },
  });

  const { values, setValues, handleSubmit } = useFormik({
    initialValues: singleAudience,
    onSubmit: (values) => {
      const payload: IMarketCampaignAudience = {
        ...values,
        ...(!values.market_campaign_uuid && {
          company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
          market_campaign_uuid: marketCampaign.market_campaign_uuid,
        }),
        audience_source: "MULTIPLE" as "EXCEL",
      };

      if (props.onRowSelect) {
        props.onRowSelect(payload);
      }

      dispatch(
        upsertMarketCampaignAudienceAsync(payload, () => {
          batch(() => {
            dispatch(
              upsertQuickSendCampaignListAsync(
                {
                  ...quickSendDataList,
                  ...(!quickSendDataList.company_outlet_uuid && {
                    company_outlet_uuid:
                      companyOutlet.comapny.company_outlet_uuid,
                  }),
                  ...(!quickSendDataList.market_campaign_uuid && {
                    market_campaign_uuid: marketCampaign.market_campaign_uuid,
                  }),
                  quick_send_list: {
                    ...quickSendDataList.quick_send_list,
                    audience_list_uuids:
                      payload.market_campaign_audience_list_uuids as string[],
                    headers: tableHeaders,
                  },
                },
                (isSuccess, result) => {
                  if (isSuccess && result) {
                    setQuickSendDataList(result);
                  }
                },
              ),
            );
            dispatch(
              upsertDraftStepAsync(
                {
                  ...draftSteps,
                  current_step: 2,
                  draft_step_data: {
                    ...draftSteps.draft_step_data,
                    step_two_data: {
                      // Persist full rows so other screens can show names
                      selected_rows: selectedRows,
                      type: "AUDIENCE_LIST",
                    },
                  },
                },
                (draftState) => {
                  onKeyChange("draftSteps", draftState);
                },
              ),
            );
            props.onNext();
          });
        }),
      );
    },
  });

  const debouncedSearchName = useDebounce(
    otherCustomStateProperties["searchByName"],
    500,
  );

  const selectedAudienceLists = React.useMemo(
    () =>
      multipleAudienceList.filter(
        (list) =>
          !!list.market_campaign_audience_list_uuid &&
          (values.market_campaign_audience_list_uuids || []).includes(
            list.market_campaign_audience_list_uuid,
          ),
      ),
    [multipleAudienceList, values.market_campaign_audience_list_uuids],
  );

  const tableHeaders = extractCombinedHeaders(selectedAudienceLists);

  const isFilterActive = !!(
    debouncedSearchName && debouncedSearchName.length > 0
  );

  const displayedRows = React.useMemo(() => {
    if (isFilterActive) return filteredApiRows;

    const seen = new Set<string>();
    const merged: IMarketCampaignAudience[] = [];
    for (const row of [...selectedRows, ...defaultApiRows]) {
      const uuid = row?.market_campaign_audience_list_uuid;
      if (!uuid || seen.has(uuid)) continue;
      seen.add(uuid);
      merged.push(row);
    }
    return merged;
  }, [isFilterActive, filteredApiRows, selectedRows, defaultApiRows]);

  // Replace the handleCustomFilterChange function with this corrected version:
  const handleCustomFilterChange = (key: string, value: any) => {
    setState((prevState) => {
      return produce(prevState, (draftState) => {
        draftState.otherCustomStateProperties[key] = value;
        // Clear searchByEventName when event type is not "OTHER SOCIAL"
      });
    });
  };

  const handleRowSelect = (
    row: IMarketCampaignAudience,
    isSelected: boolean,
  ) => {
    const newState = produce(values, (draft) => {
      const uuid = row.market_campaign_audience_list_uuid || "";
      const source = row.source_link?.[0];
      const campaignName =
        marketCampaign?.campaign_name ||
        draftSteps?.draft_step_data?.step_one_data?.campaign_name ||
        "";

      // normalize arrays once
      draft.market_campaign_audience_list ??= [];
      draft.market_campaign_audience_list_uuids ??= [];
      draft.source_link ??= [];

      if (isSelected) {
        // avoid duplicates
        if (!draft.market_campaign_audience_list_uuids.includes(uuid)) {
          draft.market_campaign_audience_list.push({
            uuid: uuid || "",
            check: false,
            name: campaignName || "Unnamed",
          });

          draft.market_campaign_audience_list_uuids.push(uuid);

          if (source) {
            draft.source_link.push(source);
          }
        }
      } else {
        draft.market_campaign_audience_list =
          draft.market_campaign_audience_list.filter(
            (item) => item.uuid !== uuid,
          );

        draft.market_campaign_audience_list_uuids =
          draft.market_campaign_audience_list_uuids.filter((id) => id !== uuid);

        if (source) {
          draft.source_link = draft.source_link.filter(
            (link) => link !== source,
          );
        }
      }
    });

    setValues(newState);

    const uuid = row.market_campaign_audience_list_uuid || "";
    if (isSelected) {
      setSelectedRows((prev) =>
        prev.some((r) => r.market_campaign_audience_list_uuid === uuid)
          ? prev
          : [...prev, row],
      );
      setQuickSendDataList((prev) => ({
        ...prev,
        quick_send_list: {
          ...prev.quick_send_list,
          audience_list_uuids: Array.from(
            new Set([...prev.quick_send_list.audience_list_uuids, uuid]),
          ),
        },
      }));
    } else {
      setSelectedRows((prev) =>
        prev.filter((r) => r.market_campaign_audience_list_uuid !== uuid),
      );
      setQuickSendDataList((prev) => ({
        ...prev,
        quick_send_list: {
          ...prev.quick_send_list,
          audience_list_uuids: prev.quick_send_list.audience_list_uuids.filter(
            (id) => id !== uuid,
          ),
        },
      }));
    }
  };

  const handlePreviewSelectedAudienceClick = (selectedFile?: any) => {
    const allRows = (selectedFile ? [selectedFile] : []).concat(selectedRows);
    if (allRows.length === 0) {
      dispatch(
        showMessage({
          type: "error",
          message: "No rows selected, returning early",
          displayAs: "snackbar",
        }),
      );
      return;
    }

    if (marketCampaign.market_campaign_uuid) {
      const combinedAudienceList = allRows.flatMap(
        (row) => row.audience_list || [],
      );
      const sourceLink = allRows.map((row) => row.source_link[0]);

      const updatedAudienceData: IMarketCampaignAudience = {
        ...(singleAudience || {}),
        market_campaign_uuid: marketCampaign.market_campaign_uuid,

        // Use new array structure for multiple audience selection
        market_campaign_audience_list_uuids: allRows.map(
          (row) => row.market_campaign_audience_list_uuid,
        ),
        // Keep old field for backward compatibility if only one audience
        market_campaign_audience_list_uuid:
          allRows.length === 1
            ? allRows[0].market_campaign_audience_list_uuid
            : undefined,
        audience_source: "MULTIPLE" as "EXCEL",
        source_link: sourceLink,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        market_campaign_audience_list: combinedAudienceList,
        audience_list: combinedAudienceList,
        campaign_rule: singleAudience.campaign_rule,
        market_campaign_audience_uuid:
          singleAudience?.market_campaign_audience_uuid,
      };

      if (props.onRowSelect) {
        props.onRowSelect(updatedAudienceData);
      }

      dispatch(
        upsertMarketCampaignAudienceAsync(updatedAudienceData, () => {
          setPreviewSelectedAudienceDialog({
            ...updatedAudienceData,
            audience_name: `Combined (${selectedRows.length})`,
            // audience_list: combinedAudienceList,
          });
          batch(() => {
            dispatch(
              upsertDraftStepAsync(
                {
                  ...draftSteps,
                  draft_step_data: {
                    ...draftSteps.draft_step_data,
                    step_two_data: {
                      selected_rows: allRows,
                    },
                  },
                },
                (draftState) => {
                  onKeyChange("draftSteps", draftState);
                },
              ),
            );
          });
        }),
      );
    } else {
      dispatch(
        showMessage({
          type: "error",
          message: "Market campaign uuid not found",
          displayAs: "snackbar",
        }),
      );
      return;
    }
  };

  const handlePreviewAudienceClick = (row?: any, selectedFile?: any) => {
    setPreviewSelectedAudienceDialog(row);
    return;

    const allRows = (selectedFile ? [selectedFile] : []).concat([row]);
    if (allRows.length === 0) {
      dispatch(
        showMessage({
          type: "error",
          message: "No rows selected, returning early",
          displayAs: "snackbar",
        }),
      );
      return;
    }

    if (marketCampaign.market_campaign_uuid) {
      const combinedAudienceList = allRows.flatMap(
        (row) => row.audience_list || [],
      );
      const sourceLink = allRows.map((row) => row.source_link[0]);

      const updatedAudienceData: IMarketCampaignAudience = {
        ...(singleAudience || {}),
        market_campaign_uuid: marketCampaign.market_campaign_uuid,

        // Use new array structure for multiple audience selection
        market_campaign_audience_list_uuids: allRows.map(
          (row) => row.market_campaign_audience_list_uuid,
        ),
        // Keep old field for backward compatibility if only one audience
        market_campaign_audience_list_uuid:
          allRows.length === 1
            ? allRows[0].market_campaign_audience_list_uuid
            : undefined,
        audience_source: "MULTIPLE" as "EXCEL",
        source_link: sourceLink,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        market_campaign_audience_list: combinedAudienceList,
        audience_list: combinedAudienceList,
        campaign_rule: singleAudience.campaign_rule,
        market_campaign_audience_uuid:
          singleAudience?.market_campaign_audience_uuid,
      };

      // if (props.onRowSelect) {
      //   props.onRowSelect(updatedAudienceData);
      // }

      dispatch(
        upsertMarketCampaignAudienceAsync(updatedAudienceData, () => {
          setPreviewSelectedAudienceDialog({
            ...updatedAudienceData,
            audience_name: `Combined (${selectedRows.length})`,
            // audience_list: combinedAudienceList,
          });
          batch(() => {
            dispatch(
              upsertDraftStepAsync(
                {
                  ...draftSteps,
                  draft_step_data: {
                    ...draftSteps.draft_step_data,
                    step_two_data: {
                      selected_rows: allRows,
                    },
                  },
                },
                (draftState) => {
                  onKeyChange("draftSteps", draftState);
                },
              ),
            );
          });
        }),
      );
    } else {
      dispatch(
        showMessage({
          type: "error",
          message: "Market campaign uuid not found",
          displayAs: "snackbar",
        }),
      );
      return;
    }
  };

  const handleAudienceSaveNext = (selectedFile?: any, isNext?: boolean) => {
    const allRows = (selectedFile ? [selectedFile] : []).concat(selectedRows);
    if (allRows.length === 0) {
      dispatch(
        showMessage({
          type: "error",
          message: "No rows selected, returning early",
          displayAs: "snackbar",
        }),
      );
      return;
    }

    if (marketCampaign.market_campaign_uuid) {
      const combinedAudienceList = allRows.flatMap(
        (row) => row.audience_list || [],
      );
      const sourceLink = allRows.map((row) => row.source_link[0]);

      const updatedAudienceData: IMarketCampaignAudience = {
        ...(singleAudience || {}),
        market_campaign_uuid: marketCampaign.market_campaign_uuid,
        // Use new array structure for multiple audience selection
        market_campaign_audience_list_uuids: allRows.map(
          (row) => row.market_campaign_audience_list_uuid,
        ),
        // Keep old field for backward compatibility if only one audience
        market_campaign_audience_list_uuid:
          allRows.length === 1
            ? allRows[0].market_campaign_audience_list_uuid
            : undefined,
        audience_source: "MULTIPLE" as "EXCEL",
        source_link: sourceLink,
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        market_campaign_audience_list: combinedAudienceList,
        audience_list: combinedAudienceList,
        campaign_rule: singleAudience.campaign_rule,
        market_campaign_audience_uuid:
          singleAudience?.market_campaign_audience_uuid,
      };

      if (props.onRowSelect) {
        props.onRowSelect(updatedAudienceData);
      }

      // dispatch(
      //   upsertMarketCampaignAudienceAsync(updatedAudienceData, () => {
      //     setPreviewSelectedAudienceDialog({
      //       ...updatedAudienceData,
      //       audience_name: `Combined (${selectedRows.length})`,
      //     });

      //     batch(() => {
      //       dispatch(
      //         upsertDraftStepAsync(
      //           {
      //             ...draftSteps,
      //             draft_step_data: {
      //               ...draftSteps.draft_step_data,
      //               step_two_data: {
      //                 selected_rows: allRows,
      //               },
      //             },
      //           },
      //           (draftState) => {
      //             onKeyChange("draftSteps", draftState);
      //           }
      //         )
      //       );

      //       if (isNext) {
      //         setPreviewSelectedAudienceDialog(null);
      //         props.onNext();
      //       }
      //     });
      //   })
      // );
    } else {
      dispatch(
        showMessage({
          type: "error",
          message: "Market campaign uuid not found",
          displayAs: "snackbar",
        }),
      );
      return;
    }
  };

  const findCurrentRowCheckStatus = (row: IMarketCampaignAudience) => {
    const currentRow = (values.market_campaign_audience_list || []).find(
      (c) => c.uuid === row.market_campaign_audience_list_uuid,
    );
    const result = !currentRow ? false : currentRow.check ? true : false;
    return result;
  };

  const isReadOnlyPreview = (row: IMarketCampaignAudience) => {
    const currentRow = (values.market_campaign_audience_list || []).find(
      (c) => c.uuid === row.market_campaign_audience_list_uuid,
    );

    return currentRow ? false : true;
  };

  const handleCreate = () => {
    setOpenCreateView({});
  };

  const marketCampaignTableProps: IDataTableV2Props = {
    isPagination: true,
    pageNumber: pagination.pageNumber,
    rowsPerPageOptions: pagination.rowsInPerPage,
    extraFetchFactor: pagination.extraFetchFactor,
    isDataLoading: loading !== LoadState.Loaded,
    showCreateButton: !(loading === LoadState.InProgress) && multipleAudienceList.length === 0 && (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Button sx={{ ml: 1 }} color="success" variant="contained" onClick={handleCreate}>
          Create Audience
        </Button>
      </Box>
    ),
    tableCommandBarProps: {
      preDefinedPlugins: {
        refresh: {
          onClick: () => {
            fetchList();
          },
        },
      },
      leftItems: {
        customPlugins: [
          {
            key: "search",
            onRender: () => (
              <CustomTextField
                variant="outlined"
                fullWidth
                label="Search by Name"
                placeholder="Search by Name"
                value={otherCustomStateProperties.searchByName}
                onChange={(e) => {
                  handleCustomFilterChange("searchByName", e.target.value);
                }}
                InputProps={{
                  endAdornment: otherCustomStateProperties.searchByName && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleCustomFilterChange("searchByName", "");
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            ),
          },
        ],
      },
      rightItems: {
        customPlugins: [],
      },
    },
    mobileColumns: [
      {
        variant: "template1",
        headingColumn: {
          key: "audience_name",
          fieldName: "audience_name",
        },
        rightHeadingColumn: {
          key: "status",
          fieldName: "status",
          onRowCellRender: (value, row: IMarketCampaignAudience) => {
            const isSelected = (
              values.market_campaign_audience_list_uuids || []
            ).some((r) => r === row.market_campaign_audience_list_uuid);
            return (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  ml: { xs: 0.5, sm: 1 },
                }}
              >
                <CustomChip color="success" content={row.status} size="small" />
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePreviewAudienceClick(row);
                  }}
                  sx={{ p: 0.5, ml: 0.5 }}
                >
                  <VisibilityOutlined fontSize="small" />
                </IconButton>
                <CustomCheckbox
                  disabled={!isEditable}
                  checked={isSelected}
                  onChange={(e, checked) => {
                    e.stopPropagation();
                    handleRowSelect(row, checked);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Box>
            );
          },
        },
        subSectionColumn: [
          {
            key: "audience_name",
            fieldName: "audience_name",
          },
        ],
        otherColumns: [
          {
            key: "audience_source",
            headerName: "Source",
            fieldName: "audience_source",
          },
          {
            key: "audience_list_count",
            headerName: "Contacts",
            fieldName: "audience_list",
            onRowCellRender: (value, row: any) => {
              return row.audience_list?.length || 0;
            },
          },
          {
            key: "create_ts",
            headerName: "Created At",
            fieldName: "create_ts",
            onRowCellRender: (value, row: any) => {
              return ftDateTime(row.create_ts);
            },
          },
        ],
        actions: [],
      },
    ],
    masterColumns: [
      {
        key: "select",
        headerName: "Select",
        fieldName: "",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        width: "120px",
        onRowCellRender: (value, row: IMarketCampaignAudience) => {
          const isSelected = (
            values.market_campaign_audience_list_uuids || []
          ).some((r) => r === row.market_campaign_audience_list_uuid);
          return (
            <Stack direction={"row"} spacing={1}>
              <IconButton onClick={() => handlePreviewAudienceClick(row)}>
                <VisibilityOutlined />
              </IconButton>
              <CustomCheckbox
                disabled={!isEditable}
                checked={isSelected}
                onChange={(e, checked) => handleRowSelect(row, checked)}
              />
            </Stack>
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        width: "150px",
        onRowCellRender: (value, row: any) => {
          return (
            <CustomChip color="success" content={row.status} size="small" />
          );
        },
      },
      {
        key: "audience_name",
        headerName: "Audience Name",
        fieldName: "audience_name",
        renderType: DataTableV2RowRenderType.TEXT,
        enableSorting: true,
      },
      {
        key: "audience_source",
        headerName: "Source",
        fieldName: "audience_source",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "audience_list_count",
        headerName: "Contacts Count",
        fieldName: "audience_list",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: any) => {
          return row.audience_list?.length || 0;
        },
      },
      {
        key: "create_ts",
        headerName: "Created At",
        fieldName: "create_ts",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        onRowCellRender: (value, row: any) => {
          return ftDateTime(row.create_ts);
        },
      },
    ],
    rows: displayedRows,
    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange,
    masterColumnResize: {
      values: masterColumnResize,
      onResize: onResizeMasterColumns,
    },
  };

  const fetchList = () => {
    dispatch(
      fetchAllMarketCampaignAudienceListAsync(
        pagination.pageNumber,
        pagination.rowsInPerPage,
        pagination.apiFetchRowCount,
        tabs.selectedTab,
        dateState.dates,
        searchState,
        companyOutlet.comapny.company_outlet_uuid,
        debouncedSearchName,
      ),
    );
  };

  const isFirstSearchRender = React.useRef(true);

  React.useEffect(() => {
    if (isFirstSearchRender.current) {
      isFirstSearchRender.current = false;
      return;
    }
    fetchList();
  }, [debouncedSearchName]);

  React.useEffect(() => {
    fetchList();
  }, [pagination]);

  React.useEffect(() => {
    if (
      !companyOutlet.comapny.company_outlet_uuid ||
      !marketCampaign.market_campaign_uuid
    )
      return;

    fetchUniqueMarketCampaignQuickSendListAsync(
      companyOutlet.comapny.company_outlet_uuid,
      marketCampaign.market_campaign_uuid,
    ).then((res) => {
      if (res) setQuickSendDataList(res);
    });
  }, [
    companyOutlet.comapny.company_outlet_uuid,
    marketCampaign.market_campaign_uuid,
  ]);

  React.useEffect(() => {
    const selectedRowsList =
      draftSteps.draft_step_data?.step_two_data?.selected_rows;

    if (multipleAudienceList.length && Array.isArray(selectedRowsList)) {
      const validRows = selectedRowsList.filter(
        (r: any) =>
          r &&
          typeof r === "object" &&
          r.market_campaign_audience_list_uuid,
      ) as IMarketCampaignAudience[];
      if (validRows.length) setSelectedRows(validRows);
    }
  }, [multipleAudienceList, draftSteps]);

  React.useEffect(() => {
    if (loading !== LoadState.Loaded) return;
    if (isFilterActive) {
      setFilteredApiRows(multipleAudienceList);
    } else {
      setDefaultApiRows(multipleAudienceList);
    }
  }, [multipleAudienceList, loading, isFilterActive]);

  React.useEffect(() => {
    if (!isFilterActive) setFilteredApiRows([]);
  }, [isFilterActive]);

  useEffect(() => {
    setValues(singleAudience);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleAudience.market_campaign_audience_uuid]);

  return (
    <>
      <PageContainer
        title="Manage Audience List"
        description="this is innerpage"
      >
        <PageTitleBar
          heading="Select an audience to proceed"
          rightHeading={
            <Button
              variant="contained"
              onClick={handleCreate}
              startIcon={<AddOutlined />}
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <Box sx={{ display: { xs: "inline", sm: "none" } }}>Create</Box>
              <Box sx={{ display: { xs: "none", sm: "inline" } }}>
                Create Audience
              </Box>
            </Button>
          }
        />
        <DataTableV2 {...marketCampaignTableProps} />

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 2 }}
          component={"form"}
          onSubmit={handleSubmit}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<NavigateBefore />}
            onClick={props.onBackClick}
          >
            Back to Data Source
          </Button>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={() => handlePreviewSelectedAudienceClick()}
            disabled={selectedRows.length === 0}
          >
            Preview Selected Audience ({selectedRows.length})
          </Button> */}

          {/* <Button
            variant="contained"
            color="primary"
            onClick={() => handleAudienceSaveNext()}
            disabled={selectedRows.length === 0}
          >
            Save & Preview ({selectedRows.length})
          </Button> */}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            // onClick={() => handleAudienceSaveNext(null, true)}
            disabled={selectedRows.length === 0 || !isEditable}
          >
            Save & Next ({values?.market_campaign_audience_list_uuids?.length})
          </Button>
        </Box>
        {openCreateView && (
          <CreateAudienceRightPanel
            open={true}
            onClose={() => setOpenCreateView(null)}
            onSuccess={(data) => {
              setOpenCreateView(null);
              fetchList();
              // handlePreviewSelectedAudienceClick(data);
            }}
            heading="Create New Audience"
          />
        )}

        {previewSelectedAudienceDialog && (
          <PreviewOrUpdateChoosenAudieneRP
            open={true}
            readonly={isReadOnlyPreview(previewSelectedAudienceDialog)}
            data={previewSelectedAudienceDialog}
            onClose={() => {
              setPreviewSelectedAudienceDialog(null);
            }}
            onSaveAndClose={(response) => {
              setValues((prev) => ({
                ...prev,
                market_campaign_audience_list: (
                  prev.market_campaign_audience_list || []
                ).map((r) => {
                  if (r.uuid === response.uuid) {
                    return {
                      ...r,
                      check: response.check,
                    };
                  }
                  return r;
                }),
              }));
              setQuickSendDataList((prev) => ({
                ...prev,
                quick_send_list: {
                  ...prev.quick_send_list,
                  selected_audience_list_operation: response.data,
                },
              }));
              setPreviewSelectedAudienceDialog(null);
            }}
            quickSendData={{
              uuid:
                previewSelectedAudienceDialog.market_campaign_audience_list_uuid ||
                "",
              check: findCurrentRowCheckStatus(previewSelectedAudienceDialog),
              data: quickSendDataList["quick_send_list"][
                "selected_audience_list_operation"
              ],
            }}
            mode="VIEW_AUDIENCE"
          />
        )}
        {/* {previewSelectedAudienceDialog && (
          <PreviewSelectedAudieneRightPanel
            open={true}
            audienceData={previewSelectedAudienceDialog}
            onClose={() => {
              setPreviewSelectedAudienceDialog(null);
            }}
            onComplete={() => {
              setPreviewSelectedAudienceDialog(null);

              props.onNext();
            }}
            mode="VIEW_AUDIENCE"
          />
        )} */}
      </PageContainer>
    </>
  );
};
